import * as React from "react";
import jfetch from "../../utils/jfetch";
import {useState,useEffect} from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {

  five: {
    breakpoint: { max: 8000, min: 1440 },
    items: 5,
  },
  four: {
    breakpoint: { max: 1440, min: 1200 },
    items: 4,
  },
  three: {
    breakpoint: { max: 1200, min: 700 },
    items: 3,
  },
  two: {
    breakpoint: { max: 700, min: 450 },
    items: 2,
  },
  one: {
    breakpoint: { max: 450, min: 0 },
    items: 1,
  },
};

function ChatBar(){
  const [rooms, set_rooms] = useState(Array);
  useEffect(() => {
    CheckLive(set_rooms);
    let handle = setInterval(() => {
      CheckLive(set_rooms);
    }, 300000);

    document.addEventListener(
      'turbolinks:load',
      () => clearInterval(handle),
    );
  }, []);
  return(
    <div className="chat-bar" style={{width : "88%", float: "left"}}>
      <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={6000} arrows={false}>
        {rooms}
      </Carousel>
    </div>
  )
}

async function CheckLive(set_rooms) {
  const streams = await jfetch.get('/streams.json');
  if(streams){
    var is_live = false;
    Object.entries(streams.stream).forEach(entry => {
      let key = entry[0];
      let value : any = entry[1];
      if(value.is_live){
        is_live = true;
      }
    });
    if(is_live){
      const res = await jfetch.get('/sponsor/rooms.json');
      if(res){
        set_rooms(
          res.rooms.map((value, i) => {
            return(<a href={`/sponsor/rooms/${value.slug}`} key={i} className="room">
            <img src={value.logo_url} className="room_img" />
            <h3 className="room_title">{value.name} Booth</h3>
            <small>Come Chat With Us!</small>
            </a>
            )
          })
        );
      }
    }
  }
}

export default ChatBar;


// WEBPACK FOOTER //
// ./app/javascript/components/preloaded/ChatRoomBar.tsx